import React from "react";
import { useNavigate } from "react-router-dom";
import MainMenuItem from "app/components/MainMenuItem";
import Path from "app/route/Path";

function ReservationMenuItem(props) {
  const navigate = useNavigate();

  const onMenuItemClicked = () => {
    navigate(Path.reservation("future"));
  };

  return (
    <MainMenuItem
      itemTitleString="予約する"
      onClick={onMenuItemClicked}
      size="100%"
    />
  );
}

export default ReservationMenuItem;
